<template>
  <div class="learn-page">
    <div class="v-szn-breadcrumb">
      <div class="breadcrumb">
        <a-breadcrumb>
          <a-breadcrumb-item href="">
            <a-icon type="home" /> 三只鸟云课堂
          </a-breadcrumb-item>
          <a-breadcrumb-item> 学习中心 </a-breadcrumb-item>
        </a-breadcrumb>
      </div>
    </div>
    <div class="now-work bg-white">
      <template v-if="null !== nowWork">
        <div class="work-name">
          <div class="name fs-24">{{ nowWork.works.name }}</div>
          <div class="plan-name">
            计划类型：{{ 1 === nowWork.plan.types ? "继续教育" : "岗前培训" }}
          </div>
          <div class="plan-name">所属计划：{{ nowWork.plan.title }}</div>
          <div class="plan-name">
            排课时间：{{ nowWork.plan.start_time }} ~
            {{ nowWork.plan.end_time }}
          </div>
        </div>

        <template v-if="1 === nowWork.plan.types">
          <div class="learn">
            <div class="learn-item">
              <a-progress
                type="circle"
                :percent="nowWork.lclass | percentage(8)"
                :width="80"
              />

              <div class="score-name fs-15">直播课</div>
            </div>
            <div class="learn-item">
              <a-progress
                type="circle"
                :percent="nowWork.gclass | percentage(20)"
                :width="80"
              />

              <div class="score-name fs-15">通用知识</div>
            </div>
            <div class="learn-item">
              <a-progress
                type="circle"
                :percent="
                  nowWork.pclass | percentage(nowWork.additional ? 24 : 12)
                "
                :width="80"
              />

              <div class="score-name fs-15">专业知识</div>
            </div>
            <div class="learn-item">
              <a-progress
                type="circle"
                :percent="nowWork.iclass | percentage(24)"
                :width="80"
              />

              <div class="score-name fs-15">自主学习</div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="gq-learn">
            <div class="line-progress">
              <a-progress :percent="nowWork.lclass*100 / 40" />
            </div>
            <div class="gq-score-desc fs-18">
              共需要
              <span class="color-orange">40</span> 学时，当前已获得
              <span class="color-orange">{{ nowWork.lclass }}</span>
              学时
            </div>
          </div>
        </template>

        <div class="action">
          <a-button icon="retweet" type="primary" @click="workChange()"
            >切换专业</a-button
          >
        </div>
      </template>
    </div>
    <div
      class="work-panel bg-white pd-12"
      v-if="workListVisible && workList.length > 1"
    >
      <a-empty description="暂无岗位数据" v-if="0 === workList.length" />

      <div class="work-lists" v-else>
        <a-divider class="notransform"
          ><span class="color-blue"
            ><a-icon type="arrow-down" />请选择学习专业<a-icon
              type="arrow-down" /></span
        ></a-divider>
        <a-row :gutter="[16, 16]" type="flex">
          <a-col :span="8" :key="workItem.id" v-for="workItem in workList">
            <a-card
              style="height:100%"
              size="small"
              :title="workItem.works.name"
              hoverable
              class="work-item"
              :class="nowWork.id === workItem.id ? 'bdc-cyan' : ''"
              @click="setNowWork(workItem)"
            >
              <div slot="extra">
                <a-icon type="environment" />{{
                  workItem.plan.province.province
                }}
              </div>
              <div class="attr-item">
                <div class="attr-item-keys">所属计划：</div>
                <div class="attr-item-value">{{ workItem.plan.title }}</div>
              </div>
              <div class="attr-item">
                <div class="attr-item-keys">计划时间：</div>
                <div class="attr-item-value">
                  {{ workItem.plan.start_time }} ~ {{ workItem.plan.end_time }}
                </div>
              </div>

              <div class="jj-learn-score">
                <a-divider class="notransform">学时统计</a-divider>
                <a-row v-if="1 === workItem.plan.types">
                  <a-col :span="6" style="text-align: center">
                    <div class="value color-darkGray">
                      <span class="fs-24 color-green">{{
                        workItem.lclass || 0
                      }}</span
                      >/8
                    </div>
                    <div class="title">直播课</div>
                  </a-col>
                  <a-col :span="6" style="text-align: center">
                    <div class="value color-darkGray">
                      <span class="fs-24 color-green">{{
                        workItem.gclass || 0
                      }}</span
                      >/20
                    </div>
                    <div class="title">通用知识</div>
                  </a-col>
                  <a-col :span="6" style="text-align: center">
                    <div class="value color-darkGray">
                      <span class="fs-24 color-green">{{
                        workItem.pclass || 0
                      }}</span
                      >/{{ workItem.additional ? 24 : 12 }}
                    </div>
                    <div class="title">专业知识</div>
                  </a-col>
                  <a-col :span="6" style="text-align: center">
                    <div class="value color-darkGray">
                      <span class="fs-24 color-green">{{
                        workItem.iclass || 0
                      }}</span
                      >/24
                    </div>
                    <div class="title">自主学习</div>
                  </a-col>
                </a-row>
                <a-row v-else>
                  <a-col :span="24">
                    <a-progress
                      :percent="
                        Math.round((workItem.lclass / 40) * 10000) / 100
                      "
                    />
                    <div class="gq-score-desc">
                      共需要
                      <span class="color-orange">40</span> 学时，当前已获得
                      <span class="color-green">{{
                        workItem.lclass || 0
                      }}</span>
                      学时
                    </div>
                  </a-col>
                </a-row>
              </div>
            </a-card>
          </a-col>
        </a-row>
      </div>
    </div>

    <a-affix :offset-top="64">
      <div class="learn-panel" v-if="null !== nowWork">
        <a-tabs class="uc-tabs" default-active-key="1" @change="tabChange">
          <a-tab-pane key="1" tab="直播课">
            <live
              :plan-id="nowWork.plan.id"
              :pwid="nowWork.id"
              :work-id="nowWork.work_types_id"
            ></live>
          </a-tab-pane>
          <template v-if="nowWork.plan.types && 1 === nowWork.plan.types">
            <a-tab-pane key="2" tab="通用知识">
              <course
                :course-type="1"
                :plan-id="nowWork.plan.id"
                :pwid="nowWork.id"
                :work-id="nowWork.work_types_id"
              ></course>
            </a-tab-pane>
            <a-tab-pane key="3" tab="岗位知识">
              <course
                :course-type="2"
                :plan-id="nowWork.plan.id"
                :pwid="nowWork.id"
                :work-id="nowWork.work_types_id"
              ></course>
            </a-tab-pane>
            <a-tab-pane key="4" tab="自主学习">
              <self-study
                :plan-id="nowWork.plan.id"
                :pwid="nowWork.id"
                :work-id="nowWork.work_types_id"
              ></self-study>
            </a-tab-pane>
          </template>

          <template slot="tabBarExtraContent">
            <span v-if="1 == tabKey" class="color-red fb"
              ><a-icon type="eye" />每观看 45 分钟计一个学时<a-icon type="eye"
            /></span>
            <span v-else-if="2 == tabKey || 3 == tabKey" class="color-red fb"
              ><a-icon
                type="eye" />每观看完一个视频计一个学时，请等待播放器自动播放完成<a-icon
                type="eye"
            /></span>
            <span v-else-if="4 == tabKey" class="color-red fb"
              ><a-icon type="eye" />请仔细阅读左侧的“用户须知”<a-icon
                type="eye"
            /></span>
          </template>
        </a-tabs>
      </div>
    </a-affix>
  </div>
</template>

<script>
import Live from "./components/Live.vue";
import Course from "./components/Course.vue";
import SelfStudy from "./components/SelfStudy.vue";
export default {
  components: {
    Live,
    Course,
    SelfStudy,
  },
  data() {
    return {
      userinfo: {},
      workListVisible: false,
      planList: [],
      workList: [],
      learnScore: {},
      nowWork: null,
      tabKey: "1",
    };
  },
  filters: {
    percentage(val, den) {
      let t = val / den;

      return t >= 1 ? 100 : Math.floor(t * 100);
    },
  },
  created() {
    this.userinfo = this.$store.get("userinfo");
    let learn = this.$store.get("learn");
    this.planList = learn.plan || [];
    this.getWorks();
  },
  methods: {
    workChange() {
      this.workListVisible = !this.workListVisible;
    },
    tabChange(key) {
      this.tabKey = key;
    },
    getWorks() {
      this.$request.common.user.works().then(({ data }) => {
        if (0 === data.errcode) {
          this.workList = data.data.items;
          this.learnScore = data.data.score || {};
          if (this.workList.length > 0) {
            this.nowWork = this.workList[0];
          }
        }
      });
    },
    setNowWork(item) {
      this.nowWork = item;
      this.workListVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.learn-page {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.learn-panel {
  flex: 1;
  margin-top: 24px;
  border-radius: 5px;
  overflow: auto;
  background: #fff;
  padding: 12px;
}
.line-progress {
  width: 100%;
}
.now-work {
  flex-shrink: 0;
  height: 132px;
  padding: 12px;
  border-radius: 5px;
  display: flex;
  .work-name {
    flex: 1;
    .name {
      padding-bottom: 8px;
    }
  }
  .learn {
    width: 640px;
    display: flex;
    padding-left: 24px;
    .learn-item {
      box-sizing: border-box;
      width: 148px;
      padding: 0 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .score-name {
        padding-top: 6px;
        text-align: center;
      }
    }
  }
  .gq-learn {
    width: 600px;
    padding-right: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .action {
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }
}
.work-item {
  &:hover {
    background: ghostWhite;
  }
}
.gq-score-desc {
  line-height: 36px;
}
.attr-item {
  line-height: 24px;
  display: flex;
  .attr-item-keys {
    width: 80px;
    flex-shrink: 0;
  }
  .attr-item-value {
    flex: 1;
  }
}
.work-panel {
  position: relative;
  border-radius: 5px;
  padding: 12px;

  &::after {
    position: absolute;
    content: " ";
    right: 40px;
    width: 0;
    height: 0;
    top: -8px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid #fff;
  }
}
.v-szn-breadcrumb {
  flex-shrink: 0;
  display: flex;
  height: 48px;
  padding: 0;
  align-items: center;
  .breadcrumb {
    flex: 1;
  }
  .extra {
    flex-shrink: 0;
    span {
      margin-left: 6px;
    }
  }
}
</style>